import { ArrowUp10 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowUp10Icon = createLucideIcon(ArrowUp10);
